const updateCategoriesErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateCategoriesErrors;
